import { render } from "./previewPDF.vue?vue&type=template&id=fc24ca3a"
import script from "./previewPDF.vue?vue&type=script&lang=js"
export * from "./previewPDF.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__